import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../UI/Button/Button';
import IconNewUI from './IconNewUI';    

const NewUI = props => {
    const keys = Object.keys(props.new);
    let content = keys.map( (key) =>{
            const k = key.split('-');
            switch( k[0] ){
                case 'title': 
                    return <h1 className="green h4 fw-700 text-uppercase mb-5" key={props.key}>{props.new[key]}</h1>;
                case 'text':
                case 'quote' : 
                    return( 
                        <p key={props.key} className={k[0] === 'quote' ? 'fw-700 font-italic' : '' }>
                            <Trans
                                key={props.key} 
                                t={props.t} 
                                i18nKey={"blog:news."+ props.id + '.content.' + key } 
                                components={{ 
                                    homeLink: <Link to={props.t('routes:homepage.path')+'#top'} />,
                                    email: <Link to="#"  onClick={(e)=> {
                                        e.preventDefault();
                                        window.location = 'mailto:qualidade@sysmatch.com';
                                        }} />,
                                    linkJobs: <Link to={props.t('routes:jobs.path')+'#top'} />  
                                } }/>
                        </p>
                    );
                case 'subTitle': return <h2 className="black h5 fw-700 text-uppercase mt-5" key={props.key}>{props.new[key]}</h2>;
                case 'image':    
                    const img = require('../../../assets/images/blog/'+ props.new[key].name + ".png");
                    let imgWebp = null;
                    if ( props.new[key].webpName ){
                        imgWebp = require('../../../assets/images/blog/'+ props.new[key].webpName + ".webp");
                    }

                    return <div key={props.key} className="wrap-img mb-5">
                                {props.srcWebp || (imgWebp && imgWebp.default) ?
                                <picture>
                                    <source srcSet={props.srcWebp ? props.srcWebp : imgWebp.default} type="image/webp" />
                                    <source src={props.src ? props.src : img.default} type="image/png" />
                                    <img src={props.src ? props.src : img.default} alt={props.alt} className="shadow-blog mb-4" />
                                </picture>:
                                <img className={props.new[key].class} src={img.default} alt={props.new[key].alt} />
                                }
                                
                            </div>;
                case 'ul': 
                    const itens = Object.values(props.new[key]);
                    return <ul className="p">{itens.map((item,i) => <li key={i}>{item}</li> )}</ul>;
                case 'btnJobs': 
                    return  <Link to={props.t('routes:jobs.path')+'#top'} >  
                                <Button key={props.key} btnClasses="p mx-0 mt-4 p-l h4 fw-600 text-uppercase">
                                    {props.new[key]}
                                </Button> 
                            </Link>;
                default: return null;
            }
        });
    let popularNews = Object.entries(props.news);
    let index = 0;

    for ( let i = 0 ; i < popularNews.length ; i++)
        if ( popularNews[i][0] === props.id )
            index = i

    popularNews.splice(index, 1);
    popularNews.reverse();
    popularNews.splice(6,Number.MAX_VALUE);
    popularNews = popularNews.map( (popularNew) => <li key={popularNew[0]}><Link to={popularNew[1].link ? popularNew[1].link : props.t('routes:blog.path')+ '/' + popularNew[0] } target={popularNew[1].link ? '_new' : '_self' } ><Button btnClasses="p-s ml-0 h5 fw-600">+</Button></Link><p>{popularNew[1].content.title}</p></li>)
    return(
        <div
            id={props.id}
            className='newUI mb-lg-5 pb-lg-5'>
                <Row>
                    <Col lg={ 7 }>
                        {content}
                        <IconNewUI t={props.t} title={props.new.title} />
                    </Col>
                    <Col lg={{ span: 4, offset:1}}>
                        <div className="popularNews">
                            <div className="title-triangle white top-md"></div>
                            <h2 className="h5 white fw-600 text-uppercase">{props.t('blog:title-aside')}</h2>
                            <ul>
                                {popularNews}
                            </ul>
                        </div>
                        <Row className="justify-content-center mt-5">
                            <div>
                                <Link className="position-relative" to={props.t('routes:blog.path')+'#top'}>
                                    <Button btnClasses="p-l p fw-600 text-uppercase mt-4 mt-lg-0 ml-0">{props.t('blog:btn-back')}</Button>
                                </Link>
                            </div>
                        </Row>
                    </Col>
                </Row>
        </div>
    );
}

export default NewUI;